import React, { useEffect,useState } from "react";
const DocumentFormView = ({fileData, page_no}) => {

	console.log('fileData',fileData)

  const [fileUrl,setFileUrl] = useState(null);


	useEffect(()=>{

		 if(fileData?.original_json?.image_to_pdf_base64){
			const binaryData = atob(fileData?.original_json?.image_to_pdf_base64);
			const arrayBuffer = new Uint8Array(binaryData.length);
			for (let i = 0; i < binaryData.length; i++) {
				arrayBuffer[i] = binaryData.charCodeAt(i);
			}
		const blob = new Blob([arrayBuffer],{ type: 'application/pdf' });
			setFileUrl(URL.createObjectURL(blob))

		}else if (fileData?.pdfstreamToBuffer){

			const buff = Buffer.from(fileData?.pdfstreamToBuffer);
			const file = new Blob([buff], { type: 'application/pdf' });
			setFileUrl(window.URL.createObjectURL(file));

		}







	},[page_no])



	return (<> {fileUrl &&
		//   <iframe src={`${fileUrl}#page=${page_no}`} id="pdf"  height="1000px" width="100%">
		<iframe style={{ overflow: "auto", border:0, maxHeight: "calc(100vh - 279px)" }} src={`${fileUrl}#page=${page_no}&view=FitH`} id="pdf"  height="1000px" width="100%">
		</iframe>}</>);
};


export default DocumentFormView;
